<template>
  <div>
    <ElasticList :list="list" :filter="filter"></ElasticList>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  export default {
    mixins: [],
    components: {
      ElasticList
    },
    props: {
      list: {
        type: Object,
        required: false
      },
      filter: {
        type: Object,
        required: false
      },
    }
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions{
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .md-card-header.list-header.list-header-hidden {
    padding-top: 12px;
  }
  .dynamicList-loading {
    position: absolute;
    top: 20px;
    left: 50%;
    transform:translateX(-50%);
    bottom: auto;
    right: auto;
    display: block;
  }
</style>
